import { api } from "./core";

// ── Feedback tickets (user ↔ OrbitLens staff, AWS-support style) ──
//
// Tickets are a cross-cutting concern, NOT observation data — they belong to
// the USER, not a galaxy. So these calls are deliberately NOT galaxy-scoped:
// no withAccount()/requireAccount() wrapper. createTicket may pass an optional
// account_login purely as filing context (which galaxy the user was viewing);
// it never gates access.
export type TicketKind = "feedback" | "bug" | "question";
export type TicketStatus =
  | "open"
  | "awaiting_staff"
  | "awaiting_user"
  | "resolved"
  | "closed";

export interface Ticket {
  id: number;
  user_id: number;
  account_id?: number | null;
  kind: TicketKind;
  status: TicketStatus;
  subject: string;
  context?: unknown;
  created_at: string;
  updated_at: string;
  message_count?: number;
}

export interface TicketMessage {
  id: number;
  ticket_id: number;
  author_kind: "user" | "staff";
  author_user_id: number;
  body: string;
  created_at: string;
}

export interface TicketWithMessages extends Ticket {
  messages: TicketMessage[];
}

export const feedbackApi = {
  create: (data: { kind: TicketKind; subject: string; body: string; account_login?: string; context?: unknown }) =>
    api.post<Ticket>("/feedback/tickets", data),
  listMine: () => api.get<Ticket[]>("/feedback/tickets"),
  get: (id: number) => api.get<TicketWithMessages>(`/feedback/tickets/${id}`),
  reply: (id: number, body: string) =>
    api.post<TicketMessage>(`/feedback/tickets/${id}/messages`, { body }),
  // Staff ticket admin (list-all / status changes) lives in the separate HQ
  // console, not the customer app — so it can never be exposed here by accident.
};
